import PinForgottenButton from './pin-forgotten-button'

export default PinForgottenButton
